jQuery(function($) {
	if ($('body.home').length < 1) return;

	var $challengeData = $('.challenge-data'), $challengeAnswer = $($challengeData.find('.slide')[0]).find('.answer > div'), challengesRightEdge = (($(window).width() - $('#masthead').width()) / 2) - $challengeAnswer.width() - parseFloat($challengeAnswer.css('paddingLeft')) - parseFloat($challengeAnswer.css('paddingRight')), $close;

	$challengeData.prepend('<a href="#" class="close">Close</a>');
	$close = $challengeData.children('.close');

	$('.challenges .c-button:not(.white-button)').on('click', function(e) {
		e.preventDefault();

		$('.challenges > .l-row').hide();
		$challengeData.show();
	});
	if (!$challengeData.hasClass('mobile')) {
		$close.css('right', challengesRightEdge + 'px');
	}
	$close.on('click', function(e) {
		e.preventDefault();
		$('.challenges > .l-row').show();
		$challengeData.hide();
	})

	$challengeData.hide();

	$(window).on('resize', function() {
		var hidden = true;
		if ($challengeData.css('display') != 'none') hidden = false;
		$challengeData.show();
		challengesRightEdge = (($(window).width() - $('#masthead').width()) / 2) - $challengeAnswer.width() - parseFloat($challengeAnswer.css('paddingLeft')) - parseFloat($challengeAnswer.css('paddingRight'));
		if (hidden) $challengeData.hide();
		if (!$challengeData.hasClass('mobile')) {
			$close.css('right', challengesRightEdge + 'px');
		} else {
			$close.css('right', '1.5rem');
		}
	});

});
